import cn from "classnames";

import Styles from "./OldGrid.module.scss";

type ColumnSize =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24;
type EvenColumnSize = 0 | 2 | 4 | 6 | 8 | 10 | 12 | 14 | 16 | 18 | 20 | 22 | 24;

export interface ColumnSizes {
  xs?: EvenColumnSize;
  sm?: EvenColumnSize;
  md?: ColumnSize;
  lg?: ColumnSize;
  xl?: ColumnSize;
}

interface ColumnProps {
  className?: string;
  children?: JSX.Element | JSX.Element[];
  padRight?: boolean;
  padLeft?: boolean;
  centerContent?: boolean;
  offset?: ColumnSizes;
  role?: React.AriaRole;
}

const DEFAULT_COLUMN_SIZE = 24;

type Maybe<T> = T | undefined;
const anyOf = function <T>(...possibleValues: [...Maybe<T>[]]): Maybe<T> {
  return possibleValues.find((x) => (x === undefined ? false : true));
};

export const OldColumn = ({
  className,
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  padRight,
  padLeft,
  centerContent,
  offset,
  role,
}: ColumnProps & ColumnSizes) => {
  const sizes = {
    xs: anyOf(xs, DEFAULT_COLUMN_SIZE),
    sm: anyOf(sm, xs, DEFAULT_COLUMN_SIZE),
    md: anyOf(md, sm, xs, DEFAULT_COLUMN_SIZE),
    lg: anyOf(lg, md, sm, xs, DEFAULT_COLUMN_SIZE),
    xl: anyOf(xl, lg, md, sm, xs, DEFAULT_COLUMN_SIZE),
  };

  const sizeStyles = Object.entries(sizes).map(([size, count]) => {
    const columnClassName = `${size}Column${count}`;
    return (Styles as any)[columnClassName]; // Not sure why the cast to any is required here
  });

  const styles = cn(
    Styles.column,
    sizeStyles,
    {
      [Styles.columnPadRight]: padRight,
      [Styles.columnPadLeft]: padLeft,
      [Styles.columnCenterContent]: centerContent,
    },
    className
  );

  return (
    <>
      {offset && (
        <OldColumn className={className} padRight={padRight} {...offset} />
      )}
      <div className={styles} role={role}>
        {children}
      </div>
    </>
  );
};
